(() => {
  "use strict";

  function initSection(root) {
    const sectionId = root.dataset.sectionId;
    const grid = root.querySelector(`#productGrid-${sectionId}`);
    const noResults = root.querySelector(`#noResults-${sectionId}`);
    const filtersPanel = root.querySelector(`#filtersPanel-${sectionId}`);
    const filtersTrigger = root.querySelector(`#filtersTrigger-${sectionId}`);
    const filtersClose = root.querySelector(`#filtersClose-${sectionId}`);
    const backdrop = root.querySelector(`#filtersBackdrop-${sectionId}`);
    const moreBtn = root.querySelector(`#moreBtn-${sectionId}`);
    const moreWrap = moreBtn ? moreBtn.closest(".filter-more") : null;

    if (!grid) return;

    /* ---------- Filtering ---------- */
    function applyFilter(tag) {
      const cards = grid.querySelectorAll(".card");
      let visibleCount = 0;

      cards.forEach((card) => {
        const tags = (card.dataset.tags || "").split(",").filter(Boolean);
        const match = tag === "all" || tags.includes(tag);
        card.style.display = match ? "" : "none";
        if (match) visibleCount++;
      });

      if (noResults) noResults.hidden = visibleCount !== 0;

      const url = new URL(window.location);
      if (tag === "all") {
        url.searchParams.delete("tag");
      } else {
        url.searchParams.set("tag", tag);
      }
      window.history.replaceState({}, "", url);
    }

    function setActivePill(activeEl) {
      root.querySelectorAll(".filter-pill, .filter-more__item").forEach((el) => {
        el.classList.remove("is-active");
      });
      activeEl.classList.add("is-active");
    }

    function initFilters() {
      const pills = root.querySelectorAll(".filter-pill[data-tag]");
      const moreItems = root.querySelectorAll(".filter-more__item[data-tag]");

      pills.forEach((pill) => {
        pill.addEventListener("click", () => {
          setActivePill(pill);
          applyFilter(pill.dataset.tag);
          closeDrawer();
        });
      });

      moreItems.forEach((item) => {
        item.addEventListener("click", () => {
          setActivePill(item);
          applyFilter(item.dataset.tag);
          closeMoreMenu();
          closeDrawer();
        });
      });

      const initialTag = new URL(window.location).searchParams.get("tag");
      if (initialTag) {
        const match = root.querySelector(
          `.filter-pill[data-tag="${initialTag}"], .filter-more__item[data-tag="${initialTag}"]`
        );
        if (match) {
          setActivePill(match);
          applyFilter(initialTag);
          return;
        }
      }
      applyFilter("all");
    }

    /* ---------- "More" dropdown ---------- */
    function closeMoreMenu() {
      if (!moreWrap) return;
      moreWrap.classList.remove("is-open");
      moreBtn.setAttribute("aria-expanded", "false");
    }

    function initMoreMenu() {
      if (!moreBtn || !moreWrap) return;

      moreBtn.addEventListener("click", (e) => {
        e.stopPropagation();
        const isOpen = moreWrap.classList.toggle("is-open");
        moreBtn.setAttribute("aria-expanded", String(isOpen));
      });

      document.addEventListener("click", (e) => {
        if (!moreWrap.contains(e.target)) closeMoreMenu();
      });

      document.addEventListener("keydown", (e) => {
        if (e.key === "Escape") closeMoreMenu();
      });
    }

    /* ---------- Mobile filter drawer ---------- */
    function openDrawer() {
      if (!filtersPanel) return;
      filtersPanel.classList.add("is-open");
      if (backdrop) backdrop.classList.add("is-open");
      document.body.style.overflow = "hidden";
      if (filtersTrigger) filtersTrigger.setAttribute("aria-expanded", "true");
    }

    function closeDrawer() {
      if (!filtersPanel) return;
      // only relevant on mobile; harmless no-op on desktop since panel has no transform there
      filtersPanel.classList.remove("is-open");
      if (backdrop) backdrop.classList.remove("is-open");
      document.body.style.overflow = "";
      if (filtersTrigger) filtersTrigger.setAttribute("aria-expanded", "false");
    }

    function initDrawer() {
      if (filtersTrigger) filtersTrigger.addEventListener("click", openDrawer);
      if (filtersClose) filtersClose.addEventListener("click", closeDrawer);
      if (backdrop) backdrop.addEventListener("click", closeDrawer);
      document.addEventListener("keydown", (e) => {
        if (e.key === "Escape") closeDrawer();
      });
    }

    /* ---------- View toggle (desktop only) ---------- */
    function initViewToggle() {
      const buttons = root.querySelectorAll(".view-btn");
      buttons.forEach((btn) => {
        btn.addEventListener("click", () => {
          buttons.forEach((b) => b.classList.remove("is-active"));
          btn.classList.add("is-active");
          grid.dataset.cols = btn.dataset.cols;
        });
      });
    }

    initFilters();
    initMoreMenu();
    initDrawer();
    initViewToggle();
  }

  function init() {
    document.querySelectorAll(".category[data-section-id]").forEach(initSection);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }

  // Re-init when the section is added/edited in the theme editor
  document.addEventListener("shopify:section:load", (e) => {
    const root = e.target.querySelector(".category[data-section-id]");
    if (root) initSection(root);
  });
})();